const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/label-elements`,
    saveCostsTable: `${API_URL}/label-element/save-costs-table`,
    saveDiscountTable: `${API_URL}/label-element/save-discount-table`
};

export default apiUrls;
